
<template>
    <div class="card-data" :class="!sm ? 'md' : ''" id="bar">
        <Tooltip
            v-show="tip"
            :tip="tip" />
        <div class="card-title">
            <h5 class="title">{{title}}</h5>
            <small v-if="sub">{{sub}}</small>
            <div style="height: 29px" v-else></div>
        </div>
        
        <div v-if="!loader">
            <Loader/>
        </div>
        <!-- <div v-else-if="detailed.length==0 && loader">
            <EmptyStateChart
            />
        </div> -->
        <div v-else-if="loader" style="position: relative">
            <div class="graph-holder" style="align-items:center">
                <ul class="icon-list">
                    <li v-for="(dates, key) in detailedNames" :key="key" class="fb" style="display:flex;justify-content: center; align-items:center"><img style="" :src="require('@/assets/icons/'+icons[key])"></li>
                </ul>
                <apexchart class="chart" type="bar" :options="chartOptions" :series="detailed" height="200"></apexchart>
            </div>
            <div class="amount-holder">
                <div class="detailed-amount" v-for="(group, key) in detailed[0].data" :key="key">
                    <h4 class="amount">
                        <ICountUp
                            :endVal="percentage(group.y)"
                            :options="options"
                            /> %
                    </h4>
                    <p class="amount-group">{{detailedNames[key]}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ICountUp from 'vue-countup-v2'
import Loader from '@/components/Loader'
import Tooltip from '@/components/Tooltip'
import EmptyStateChart from '@/components/EmptyStateChart'

export default {
    name: 'LoginGraphCard',
    components: {
        ICountUp,
        Loader,
        Tooltip,
        EmptyStateChart
    },
    props: {
        title: {
            type: String,
            required: true
        },
        sub: {
            type: String,
            required: false
        },
        detailed: {
            type: Array,
            required: false
        },
        detailedNames: {
            type: Array,
            required: false
        },
        tip: {
            type: String,
            required: false
        },
        sm: {
            type: Boolean,
            required: false
        },
        loader: {
            type: Boolean,
            required: true
        },
        total: {
            required: false,
            type: Number
        },
        captionEmpty:{
            type: String,
            default: "Puedes consultar la vista de los últimos 7 o 30 días.",
        },
        titleEmpty: {
            type: String,
            default: "Este gráfico no esta disponible para esta vista"
        },
        icons: {
            type: Array,
            required: false
        }
    },
    data: function(){
        return {
            per: 0,
            tooltip: false,
            options: {
                useEasing: true,
                useGrouping: true,
                duration: 0.6,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: ''
            },
        }
    },
    methods: {
        closeTip: function(){
            if (this.tooltip){
                this.tooltip = false;
            }
        },
        percentage: function(item){
            let total = 0;
            _.each(this.detailed[0].data, (value) => {
                total += value['y'];
            });
            if (total === 0) {
                return '';
            }
            return (item * 100) / total;
        }
    },
    computed: {
        chartOptions: function() {
            return {  
                chart: {
                    type: 'bar',
                    height: 200,
                    animations: {
                        enabled: false
                    },
                    toolbar:{
                        show: false,
                    }
                },
                dataLabels: {
                    enabled: false
                },
                plotOptions:{
                    bar:{
                        horizontal: true,
                        startingShape: 'flat',
                        endingShape: 'flat',
                        barHeight:'45%' 
                    }
                },
                yaxis:{
                    show: false
                },
                xaxis:{
                    categories:this.detailedNames,
                    max: 100,
                    tickAmount: 2,
                    labels:{
                        formatter: function(value){
                            return value+"%"
                        }
                    },
                },
                tooltip: {
                    enabled: false,
                    y:{
                        formatter: function(value){
                            return value+"%"
                        }
                    },
                },
            }
        },
    },
    directives: {
        clickoutside: {
            bind: function (el, binding, vnode) {
                el.clickOutsideEvent = function (event) {
                // here I check that click was outside the el and his childrens
                if (!(el == event.target || el.contains(event.target))) {
                    // and if it did, call method provided in attribute value
                    vnode.context[binding.expression](event);
                }
                };
                document.body.addEventListener('click', el.clickOutsideEvent)
            },
            unbind: function (el) {
                document.body.removeEventListener('click', el.clickOutsideEvent)
            },
            stopProp(event) { event.stopPropagation() }
        }
    }
}
</script>

<style lang="sass">
.card-data.lg-row 
    grid-row-end: span 2
.card-data .chart
    margin: 5px auto
    display:block
    width: 95%
    @include tablet-landscape
        height: 80%
.graph-holder
    display: flex
    flex-direction: row
    justify-content: center
    align-items: flex-start
    ul.icon-list
        list-style: none
        height: 140px
        display: flex
        flex-direction: column
        justify-content: space-evenly
        align-items: center
        padding-bottom: 16px
        li
            border-radius: 8px
            padding: 4px
            box-sizing: border-box
            width: 32px
            height: 32px
            &.fb
                background: none
                .icon
                    color: $facebook
            &.mail 
                background: none
                margin-bottom: 34px
                .icon
                    color: $mail

            .icon
                font-size: 24px
                width: 24px
                height: 24px
                margin: 0
    .chart
        height: 200px
        margin-left: -20px
.amount-holder
    display: flex
    flex-direction: row
    align-items: start
    justify-content: space-around
    .detailed-amount 
        flex-basis: 20%;
        margin: 0 8px
        flex-direction: column
        flex-grow: 1
        .amount
            font-family: $title-font
            font-size: 24px
            font-weight: 600
            text-align: center
            color: #302f2f
        .amount-group 
            font-family: $body-font
            font-size: 12px
            font-weight: 300
            text-align: center
            color: #302f2f
            margin-bottom: 14px

</style>